import { DEFAULTS } from "./defaultSettings";
import { nodeViewDecorators } from "./nodeViewDecorators";
import { MENTION_TYPE } from "./types";
const pluginMentions = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: MENTION_TYPE,
    nodeViewDecorators
  };
};
export {
  pluginMentions
};
//# sourceMappingURL=viewer.js.map
